import { render, staticRenderFns } from "./AddressLoading.vue?vue&type=template&id=162942d8"
import script from "./AddressLoading.vue?vue&type=script&lang=js"
export * from "./AddressLoading.vue?vue&type=script&lang=js"
import style0 from "./AddressLoading.vue?vue&type=style&index=0&id=162942d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports